/**
 * Country names.
 * @type {Object}
 */
const COUNTRY_NAME = {
  AFGHANISTAN: 'Afghanistan',
  ALAND_ISLANDS: 'Aland Islands',
  ALBANIA: 'Albania',
  ALGERIA: 'Algeria',
  AMERICAN_SAMOA: 'American Samoa',
  ANDORRA: 'Andorra',
  ANGOLA: 'Angola',
  ANGUILLA: 'Anguilla',
  ANTARCTICA: 'Antarctica',
  ANTIGUA_BARBUDA: 'Antigua Barbuda',
  ARGENTINA: 'Argentina',
  ARMENIA: 'Armenia',
  ARUBA: 'Aruba',
  ASCENSION: 'Ascension',
  AUSTRALIA: 'Australia',
  AUSTRIA: 'Austria',
  AZERBAIJAN: 'Azerbaijan',
  AZORES: 'Azores',
  BAHAMAS: 'Bahamas',
  BAHRAIN: 'Bahrain',
  BALEARIC_ISLANDS: 'Balearic Islands',
  BANGLADESH: 'Bangladesh',
  BARBADOS: 'Barbados',
  BELARUS: 'Belarus',
  BELGIUM: 'Belgium',
  BELIZE: 'Belize',
  BENIN: 'Benin',
  BERMUDA: 'Bermuda',
  BES_ISLANDS: 'Bes Islands',
  BHUTAN: 'Bhutan',
  BOLIVIA: 'Bolivia',
  BONAIRE: 'Bonaire',
  BOSNIA_HERZ: 'Bosnia Herz',
  BOTSWANA: 'Botswana',
  BOUVET_ISLAND: 'Bouvet Island',
  BRAZIL: 'Brazil',
  BRUNEI: 'Brunei',
  BR_IND_OCEAN_TR: 'Br Ind Ocean Tr',
  BR_VIRGIN_ISL: 'Br Virgin Isl',
  BULGARIA: 'Bulgaria',
  BURKINA_FASO: 'Burkina Faso',
  BURMA: 'Burma',
  BURUNDI: 'Burundi',
  CAMBODIA: 'Cambodia',
  CAMEROON: 'Cameroon',
  CANADA: 'Canada',
  CANARY_ISLANDS: 'Canary Islands',
  CAPE_VERDE: 'Cape Verde',
  CAYMAN_ISLANDS: 'Cayman Islands',
  CENTRAL_AFRICAN_REPUBLIC: 'Central African Republic',
  CHAD: 'Chad',
  CHANNEL_ISLANDS: 'Channel Islands',
  CHILE: 'Chile',
  CHINA: 'China',
  CHRISTMAS_ISLAND: 'Christmas Island',
  COCOS_ISLANDS: 'Cocos Islands',
  COLOMBIA: 'Colombia',
  COMOROS: 'Comoros',
  CONGO: 'Congo',
  CONGO_DEMOCRATIC_REPUBLIC: 'Congo Democratic Republic',
  COOK_ISLANDS: 'Cook Islands',
  CORSICA: 'Corsica',
  COSTA_RICA: 'Costa Rica',
  COTE_D_IVOIRE: 'Cote D Ivoire',
  CROATIA: 'Croatia',
  CUBA: 'Cuba',
  CURACAO: 'Curacao',
  CYPRUS: 'Cyprus',
  CZECH_REPUBLIC: 'Czech Republic',
  DENMARK: 'Denmark',
  DJIBOUTI: 'Djibouti',
  DOMINICA: 'Dominica',
  DOMINICAN_REPUBLIC: 'Dominican Republic',
  DUTCH_CARIBBEAN: 'Dutch Caribbean',
  EAST_TIMOR: 'East Timor',
  ECUADOR: 'Ecuador',
  EGYPT: 'Egypt',
  EL_SALVADOR: 'El Salvador',
  ENGLAND: 'England',
  EQUATORIAL_GUINEA: 'Equatorial Guinea',
  ERITREA: 'Eritrea',
  ESTONIA: 'Estonia',
  ETHIOPIA: 'Ethiopia',
  FALKLAND_ISLANDS: 'Falkland Islands',
  FAROE_ISLANDS: 'Faroe Islands',
  FIJI: 'Fiji',
  FINLAND: 'Finland',
  FRANCE: 'France',
  FRENCH_GUIANA: 'French Guiana',
  FRENCH_POLYNESIA: 'French Polynesia',
  FR_S_TERRITORY: 'Fr S Territory',
  GABON: 'Gabon',
  GAMBIA: 'Gambia',
  GAZA: 'Gaza',
  GEORGIA: 'Georgia',
  GEORGIA_SANDWICH: 'Georgia Sandwich',
  GERMANY: 'Germany',
  GHANA: 'Ghana',
  GIBRALTAR: 'Gibraltar',
  GREAT_BRITAIN: 'Great Britain',
  GREECE: 'Greece',
  GREENLAND: 'Greenland',
  GRENADA: 'Grenada',
  GUADELOUPE: 'Guadeloupe',
  GUAM: 'Guam',
  GUATEMALA: 'Guatemala',
  GUERNSEY: 'Guernsey',
  GUINEA: 'Guinea',
  GUINEA_BISSAU: 'Guinea Bissau',
  GUYANA: 'Guyana',
  HAITI: 'Haiti',
  HEARD_MC_DONALD: 'Heard Mc Donald',
  HOLLAND: 'Holland',
  HOLY_SEE: 'Holy See',
  HONDURAS: 'Honduras',
  HONG_KONG: 'Hong Kong',
  HUNGARY: 'Hungary',
  ICELAND: 'Iceland',
  INDIA: 'India',
  INDONESIA: 'Indonesia',
  IRAN: 'Iran',
  IRAQ: 'Iraq',
  IRELAND: 'Ireland',
  ISLE_OF_MAN: 'Isle Of Man',
  ISRAEL: 'Israel',
  ITALY: 'Italy',
  JAMAICA: 'Jamaica',
  JAPAN: 'Japan',
  JERSEY: 'Jersey',
  JORDAN: 'Jordan',
  KAZAKHSTAN: 'Kazakhstan',
  KEELING_ISLANDS: 'Keeling Islands',
  KENYA: 'Kenya',
  KIRIBATI: 'Kiribati',
  KOREA: 'Korea',
  KOREA_DEM_REP: 'Korea Dem Rep',
  KOSOVA: 'Kosova',
  KOSOVO: 'Kosovo',
  KUWAIT: 'Kuwait',
  KYRGYZSTAN: 'Kyrgyzstan',
  LAOS: 'Laos',
  LATVIA: 'Latvia',
  LEBANON: 'Lebanon',
  LESOTHO: 'Lesotho',
  LIBERIA: 'Liberia',
  LIBYA: 'Libya',
  LIECHTENSTEIN: 'Liechtenstein',
  LITHUANIA: 'Lithuania',
  LUXEMBOURG: 'Luxembourg',
  MACAU: 'Macau',
  MACEDONIA: 'Macedonia',
  MADAGASCAR: 'Madagascar',
  MADIERA: 'Madiera',
  MALAWI: 'Malawi',
  MALAYSIA: 'Malaysia',
  MALDIVES: 'Maldives',
  MALI: 'Mali',
  MALTA: 'Malta',
  MALVINAS: 'Malvinas',
  MARSHALL_ISLNDS: 'Marshall Islnds',
  MARTINIQUE: 'Martinique',
  MAURITANIA: 'Mauritania',
  MAURITIUS: 'Mauritius',
  MAYOTTE: 'Mayotte',
  MEXICO: 'Mexico',
  MICRONESIA: 'Micronesia',
  MOLDOVA: 'Moldova',
  MONACO: 'Monaco',
  MONGOLIA: 'Mongolia',
  MONTENEGRO: 'Montenegro',
  MONTSERRAT: 'Montserrat',
  MOROCCO: 'Morocco',
  MOZAMBIQUE: 'Mozambique',
  MYANMAR: 'Myanmar',
  NAMIBIA: 'Namibia',
  NAURU: 'Nauru',
  NEPAL: 'Nepal',
  NETHERLANDS: 'Netherlands',
  NEW_CALEDONIA: 'New Caledonia',
  NEW_ZEALAND: 'New Zealand',
  NICARAGUA: 'Nicaragua',
  NIGER: 'Niger',
  NIGERIA: 'Nigeria',
  NIUE: 'Niue',
  NORFOLK_ISLAND: 'Norfolk Island',
  NORTHERN_IRELAND: 'Northern Ireland',
  NORTH_KOREA: 'North Korea',
  NORWAY: 'Norway',
  N_MARIANA_ISLAND: 'N Mariana Island',
  OMAN: 'Oman',
  PAKISTAN: 'Pakistan',
  PALAU: 'Palau',
  PALESTINE: 'Palestine',
  PANAMA: 'Panama',
  PAPUA_N_GUINEA: 'Papua N Guinea',
  PARAGUAY: 'Paraguay',
  PERU: 'Peru',
  PHILIPPINES: 'Philippines',
  PITCAIRN: 'Pitcairn',
  POLAND: 'Poland',
  PORTUGAL: 'Portugal',
  PRINCIPE: 'Principe',
  PUERTO_RICO: 'Puerto Rico',
  QATAR: 'Qatar',
  REUNION: 'Reunion',
  ROMANIA: 'Romania',
  RUSSIA: 'Russia',
  RWANDA: 'Rwanda',
  SABA: 'Saba',
  SAINT_HELENA: 'Saint Helena',
  SAINT_LUCIA: 'Saint Lucia',
  SAINT_MARTIN: 'Saint Martin',
  SAMOA: 'Samoa',
  SAN_MARINO: 'San Marino',
  SAUDI_ARABIA: 'Saudi Arabia',
  SCOTLAND: 'Scotland',
  SENEGAL: 'Senegal',
  SERBIA: 'Serbia',
  SEYCHELLES: 'Seychelles',
  SICILY: 'Sicily',
  SIERRA_LEONE: 'Sierra Leone',
  SINGAPORE: 'Singapore',
  SINT_EUSTATIUS: 'Sint Eustatius',
  SINT_MAARTEN: 'Sint Maarten',
  SLOVAKIA: 'Slovakia',
  SLOVENIA: 'Slovenia',
  SOLOMON_ISLANDS: 'Solomon Islands',
  SOMALIA: 'Somalia',
  SOUTH_AFRICA: 'South Africa',
  SOUTH_KOREA: 'South Korea',
  SOUTH_SUDAN: 'South Sudan',
  SPAIN: 'Spain',
  SPANISH_NORTH_AFRICAN_TERR: 'Spanish North African Terr',
  SRI_LANKA: 'Sri Lanka',
  ST_BARTHELEMY: 'St Barthelemy',
  ST_CROIX: 'St Croix',
  ST_KITTS_NEVIS: 'St Kitts Nevis',
  ST_PIERRE_MIQ: 'St Pierre Miq',
  ST_THOMAS: 'St Thomas',
  ST_VINCENT_GREN: 'St Vincent Gren',
  SUDAN: 'Sudan',
  SURICOUNTRY_NAME: 'Suriname',
  SVALBARD: 'Svalbard',
  SWAZILAND: 'Swaziland',
  SWEDEN: 'Sweden',
  SWITZERLAND: 'Switzerland',
  SYRIA: 'Syria',
  S_TOME_PRINCIPE: 'S Tome Principe',
  TAIWAN: 'Taiwan',
  TAJIKSTAN: 'Tajikstan',
  TANZANIA: 'Tanzania',
  THAILAND: 'Thailand',
  TIBET: 'Tibet',
  TIMOR_LESTE: 'Timor Leste',
  TOGO: 'Togo',
  TOKELAU: 'Tokelau',
  TONGA: 'Tonga',
  TORTOLA: 'Tortola',
  TRINIDAD_TOBAGO: 'Trinidad Tobago',
  TRISTAN_DA_CUNH: 'Tristan Da Cunh',
  TUNISIA: 'Tunisia',
  TURKEY: 'Turkey',
  TURKMENISTAN: 'Turkmenistan',
  TURKS_CAICOS: 'Turks Caicos',
  TUVALU: 'Tuvalu',
  UGANDA: 'Uganda',
  UKRAINE: 'Ukraine',
  UNITED_ARAB_EMR: 'United Arab Emr',
  UNITED_KINGDOM: 'United Kingdom',
  UNITED_STATES: 'United States',
  URUGUAY: 'Uruguay',
  US_MINOR_ISLNDS: 'Us Minor Islnds',
  US_VIRGIN_ISL: 'Us Virgin Isl',
  UZBEKISTAN: 'Uzbekistan',
  VANUATU: 'Vanuatu',
  VATICAN: 'Vatican',
  VENEZUELA: 'Venezuela',
  VIETNAM: 'Vietnam',
  WALES: 'Wales',
  WALLIS_FUTUNA: 'Wallis Futuna',
  WESTERN_SAHARA: 'Western Sahara',
  WESTERN_SAMOA: 'Western Samoa',
  YEMEN: 'Yemen',
  ZAIRE: 'Zaire',
  ZAMBIA: 'Zambia',
  ZIMBABWE: 'Zimbabwe'
}

export {
  COUNTRY_NAME
}
